/* eslint-disable jsx-a11y/label-has-associated-control */
import { Col } from "react-bootstrap";
import InputMask from "react-input-mask";

interface ICheckinProps {
    minutosIniciais: string;
    minutosFinais: string;
    setMinutosIniciais: (value: string) => void;
    setMinutosFinais: (value: string) => void;
}

const CheckHorario = (e: string) => {
    const hora = e.split(":")[0];
    const minuto = e.split(":")[1];

    if (Number(hora) > 23 || Number(minuto) > 59) {
        return false;
    }
    if (!Number(hora + 1)) return false;
    // eslint-disable-next-line sonarjs/prefer-single-boolean-return
    if (!Number(minuto + 1)) return false;

    return true;
};

const CheckinTolerance: React.FC<ICheckinProps> = ({
    minutosIniciais,
    minutosFinais,
    setMinutosIniciais,
    setMinutosFinais,
}) => {
    return (
        <>
            <Col>
                <div className="form-floating">
                    <InputMask
                        mask="99:99"
                        className="form-control"
                        id="MinutosIniciais"
                        style={{
                            marginTop: 9,
                            width: 130,
                            color: CheckHorario(minutosIniciais)
                                ? "black"
                                : "red",
                            borderColor: CheckHorario(minutosIniciais)
                                ? "#787878"
                                : "red",
                        }}
                        placeholder="00:00"
                        value={minutosIniciais}
                        onBlur={() =>
                            CheckHorario(minutosIniciais)
                                ? null
                                : setMinutosIniciais(`00:15`)
                        }
                        onChange={(e) =>
                            setMinutosIniciais(`${e.target.value}`)
                        }
                        min="1"
                        max="59"
                        required
                    />
                    <label
                        htmlFor="MinutosIniciais"
                        style={{
                            color: CheckHorario(minutosIniciais)
                                ? "black"
                                : "red",
                        }}
                    >
                        Minutos iniciais
                    </label>
                </div>
            </Col>
            <Col>
                <div className="form-floating">
                    <InputMask
                        className="form-control"
                        id="MinutosFinais"
                        mask="99:99"
                        style={{
                            marginTop: 9,
                            width: 130,
                            color: CheckHorario(minutosFinais)
                                ? "black"
                                : "red",
                            borderColor: CheckHorario(minutosFinais)
                                ? "#787878"
                                : "red",
                        }}
                        placeholder="00:00"
                        value={minutosFinais}
                        onBlur={() =>
                            CheckHorario(minutosFinais)
                                ? null
                                : setMinutosFinais(`00:15`)
                        }
                        onChange={(e) => setMinutosFinais(`${e.target.value}`)}
                        required
                    />
                    <label
                        htmlFor="MinutosFinais"
                        style={{
                            color: CheckHorario(minutosFinais)
                                ? "black"
                                : "red",
                        }}
                    >
                        Minutos finais
                    </label>
                </div>
            </Col>
        </>
    );
};

export default CheckinTolerance;
